import { KLine, Tick } from '../../../../model/canister/KLine';
import {
  LibrarySymbolInfo,
  Bar
} from '../../../../static/charting_library/charting_library.min';
import { IHistoryProvider } from '../interface';
import { parseResolutionToTickSpaceIndex } from '../utils';

export class EX3HistoryProvider implements IHistoryProvider {
  private priceDecimals = 0;
  private baseTokenDecimals = 0;
  private klineCanisterId = '';

  constructor(
    klineCanisterId: string,
    priceDecimals: number,
    baseTokenDecimals: number
  ) {
    this.klineCanisterId = klineCanisterId;
    this.priceDecimals = priceDecimals;
    this.baseTokenDecimals = baseTokenDecimals;
  }

  async getBars(
    symbolInfo: LibrarySymbolInfo,
    resolution: string,
    rangeStartDate: number,
    rangeEndDate: number,
    firstDataRequest: boolean
  ): Promise<Array<Bar>> {
    console.debug(
      'ex3 history getBars',
      symbolInfo,
      resolution,
      rangeStartDate,
      rangeEndDate,
      firstDataRequest
    );
    if (!firstDataRequest) return [];
    try {
      const tick = parseResolutionToTickSpaceIndex(resolution);
      const historyData: Array<Tick> = await new KLine(
        this.klineCanisterId
      ).fetchTicks(tick, 0, 1000);

      const { priceDecimals, baseTokenDecimals } = this;
      if (!historyData[0]) return [];
      const bars = historyData.map(
        ({ open, high, low, close, volume, time }) => ({
          time: time,
          open: open.shiftedBy(-priceDecimals).toNumber(),
          high: high.shiftedBy(-priceDecimals).toNumber(),
          low: low.shiftedBy(-priceDecimals).toNumber(),
          close: close.shiftedBy(-priceDecimals).toNumber(),
          volume: volume.shiftedBy(-baseTokenDecimals).toNumber()
        })
      );
      console.debug(`get kline history count ${bars.length}`);
      return bars.reverse();
    } catch (error) {
      console.error('fetchTicks', error);
      return [];
    }
  }
}
